import { get_parsed_jwt_identity } from "./utils.js";
import "./scripts.js";
import "./animations.js";
import "./worldmap.js";

document.addEventListener("DOMContentLoaded", () => {
  // 1. Initialize Dashboard Button Logic (T1)
  const handleInitRedirect = (e) => {
    const userData = get_parsed_jwt_identity();
    if (userData && userData.role) {
      e.preventDefault();
      const dashboardUrl =
        userData.role === "chairman"
          ? "superadmindashboard.html"
          : "admindashboard.html";
      window.location.href = dashboardUrl;
    }
  };

  const heroBtn = document.getElementById("hero-init-btn");
  const ctaBtn = document.getElementById("cta-init-btn");

  if (heroBtn) heroBtn.addEventListener("click", handleInitRedirect);
  if (ctaBtn) ctaBtn.addEventListener("click", handleInitRedirect);

  // tsParticles initialization logic from landing.html
  tsParticles.load("tsparticles", {
    fpsLimit: 60,
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "repulse",
        },
        resize: true,
      },
      modes: {
        repulse: {
          distance: 100,
          duration: 0.4,
        },
      },
    },
    particles: {
      color: {
        value: ["#066fff", "#a020f0", "#404040"],
      },
      links: {
        color: "#404040",
        distance: 160,
        enable: true,
        opacity: 0.65,
        width: 1.2,
      },
      collisions: {
        enable: true,
      },
      move: {
        direction: "none",
        enable: true,
        outModes: {
          default: "bounce",
        },
        random: false,
        speed: 1.2,
        straight: false,
      },
      number: {
        density: {
          enable: true,
          area: 800,
        },
        value: 100,
      },
      opacity: {
        value: 0.65,
      },
      shape: {
        type: "circle",
      },
      size: {
        value: { min: 1, max: 7 },
      },
    },
    detectRetina: true,
  });
});
